import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class SharedDetailNewsService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    /**
     * getDetailNews() - Buscar detalhes da notícia
     * @param postId : Identificador da notícia
     */
    getDetailNews(slug): Observable<any> {
        //console.log('getDetailNews');

        // Instancia do body através de BaseService.setBody();
        let body = this.setBody();
        // Inicializar o id do post selecionado
        body.set('slug', slug);

        let response = this.http
            .post(this.urlService + this.routeAdress.route_detail_news, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }
}
